export const hasQuestionHistoryScore = (score: number | null | undefined): score is number =>
  score != null && Number.isFinite(score);
